import { PatientInformationConstants } from './patientInformation.constants'
import { IPatientInformationAction, IPatientInformationState } from './patientInformation.types'

export const initialPatientInformationState: IPatientInformationState = {
  selectedOption: PatientInformationConstants.PATIENT_DEMOGRAPHICS_OPTION,
  hidePatientAndBilling: false,
  searchImport: false,
  newPatient: false,
  hasPatient: false,
  __enablePageScroll: false,
}

export function PatientInformationReducer(
  state: IPatientInformationState = initialPatientInformationState,
  action: IPatientInformationAction
): IPatientInformationState {
  switch (action.type) {
    case PatientInformationConstants.NOT_IMPLEMENTED:
      alert('Not implemented')
      return state
    case PatientInformationConstants.SET_SELECTED_OPTION:
      return { ...state, selectedOption: action.selectedOption }
    case PatientInformationConstants.SET_HIDE_PATIENT_AND_BILLING:
      return { ...state, hidePatientAndBilling: action.hidePatientAndBilling }
    case PatientInformationConstants.SET_SEARCH_IMPORT:
      return { ...state, searchImport: action.searchImport }
    case PatientInformationConstants.SET_NEW_PATIENT:
      return { ...state, newPatient: action.newPatient }
    case PatientInformationConstants.SET_PATIENT_INFORMATION:
      return { ...action.patientInformation }
    case PatientInformationConstants.ENABLE_PAGE_SCROLL:
      return { ...state, __enablePageScroll: action.__enablePageScroll }
    case PatientInformationConstants.SET_HAS_PATIENT:
      return { ...state, hasPatient: action.hasPatient }
    case PatientInformationConstants.SET_PATIENT_INFORMATION_STATE:
      return { ...state, ...action.patientInformation }
    case PatientInformationConstants.RESET_PATIENT_INFORMATION_STATE:
      return {
        selectedOption: PatientInformationConstants.PATIENT_DEMOGRAPHICS_OPTION,
        hidePatientAndBilling: false,
        searchImport: false,
        newPatient: false,
        hasPatient: false,
        __enablePageScroll: false,
      }
    default:
      return state
  }
}
